






































import {Component, Mixins, Prop, Ref, Vue} from 'vue-property-decorator';
    import JdhModalDialog from "@/design-system/shared/JdhModalDialog.vue"
    import TextProviderMixin from "@/design-system/utilities/TextProviderMixin"
    import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
    import AnalyticsEmitterMixin
        from "@/design-system/foundation/AnalyticsProvider/AnalyticsEmitterMixin"
    import {AcquireFirstFocus} from "../../utilities/FocusHelper"
import { JdsError } from '@/design-system/utilities/JdsError';

    /**
     * @status stable
     * @published 5.0.0
     * @changelog 5.0.0 Published.
     * @changelog 5.1.0 Add analytics events.
     * @changelog 6.2.3 Add size prop.
     * @changelog 6.7.0 Add support for a flip side.
     * @changelog 6.8.0 Fix non-functioning close and cancel promise parameters and events.
     *
     * @typed
     *
     * @analytics jds.dialog:cancel Fired on user-initiated dialog canceling.
     * @analyticsParam jds.dialog:cancel trigger Either `backdrop` or `button`, which the user clicked on to cancel this dialog. Backdrop also includes the escape key.
     * @analyticsParam jds.dialog:cancel duration How long, in milliseconds, the dialog stayed open.
     */
    @Component({
        components: {JdhModalDialog}
    })
    export default class JdsDialog extends Mixins(UniqueIdMixin, AnalyticsEmitterMixin) {
        @Prop() icon!: string;
        @Prop({default: false, type: Boolean}) allowOverflow!: boolean
        @Prop({default: 'normal'}) size!: 'normal'|'wide'|'narrow'

        @Ref() helperEl!: HTMLElement;

        isFlipped: boolean = false;
        state = false
        openedAtTimestamp: number = Date.now();

        protected onClose?: (v?: unknown) => any;
        protected onCancel?: (v?: unknown) => any;


        /**
         * Open this dialog.
         *
         * @public
         */
        open() {
            this.state = true
            this.isFlipped = false
            this.openedAtTimestamp = Date.now()

            return new Promise<unknown>((res, err) => {
                this.onClose = res;
                this.onCancel = () => {
                    err(new JdsError('Dialog cancelled', (this.$options.name as string), 'cancel'));
                };
            });
        }

        /**
         * Close this dialog, after executing its function.
         *
         * @public
         */
        close() {
            this.state = false
            this.$emit('close');
            if (this.onClose) this.onClose();
        }

        /**
         * Reveal the opposite side of the dialog, populated by the `back` slot.
         *
         * @public
         * @experimental
         */
        flip() {
            this.isFlipped = !this.isFlipped
        }

        cancelViaBackdrop() {
            this.$analytics('jds.dialog:cancel', { trigger: 'backdrop', duration: Date.now() - this.openedAtTimestamp })
            this.cancel()
        }

        cancelViaButton() {
            this.$analytics('jds.dialog:cancel', { trigger: 'button', duration: Date.now() - this.openedAtTimestamp  })
            this.cancel()
        }

        /**
         * Cancel this dialog, marking it as incomplete.
         *
         * @public
         */
        cancel() {
            this.state = false
            this.$emit('cancel');
            if (this.onCancel) this.onCancel();
        }
    }
